module.exports = __webpack_public_path__ + "img/d201107-1.4441bbff.jpg";